import {getLocalizationService} from '~/shared/services/localisationService';

import {NoReordersWrapper, NoReordersImage, NoReordersText} from './dropdown.styled';

type NoReordersProps = {
  isPage?: boolean;
};

const NoReorders = ({isPage}: NoReordersProps) => {
  const {t} = getLocalizationService();

  return (
    <NoReordersWrapper isPage={isPage}>
      <NoReordersImage alt={t('no_reorders')} />
      <NoReordersText>{t('no_reorders')}</NoReordersText>
    </NoReordersWrapper>
  );
};

export default NoReorders;
